import React from 'react';

function Alink(props) {
  return (
    <a
      href={props.href}
      onClick={(e) => {
        e.preventDefault();
        document.querySelector(props.href).scrollIntoView({
          behavior: "smooth"
        });
      }}
    >{props.children}</a>
  );
}

export default Alink;